import { authToken, instance, setParams,instanceex } from "./xhr";
import { LOGIN, SIGNUP,USERINFO,ACTIONS , ADDDOMAIN , PAY } from "./constants";

export const login = async (body) => {
    const response = await instance.post(`${LOGIN}`, body);
    return response.data;  // Return the data directly (which includes the token)
};
export const register = async (body) => {
    const response = await instance.post(`${SIGNUP}`, body);
    return response.data;  // Return the data directly (which includes the token)
};
export const userinfo = async (body) => {
    const response = await instance.post(`${USERINFO}`, body);
    return response.data;  // Return the data directly (which includes the token)
};
export const actions = async (body) => {
    const response = await instance.post(`${ACTIONS}`, body);
    return response.data;  // Return the data directly (which includes the token)
};
export const addanew = async (body,path) => {
    const response = await instance.post(`${path}`, body);
    return response.data;  // Return the data directly (which includes the token)
};
export const adddomain = async (body) => {
    const response = await instance.post(`${ADDDOMAIN}`, body);
    return response.data;  // Return the data directly (which includes the token)
};
export const getpay = async (body) => {
    const response = await instance.post(`${PAY}`, body);
    return response.data;  // Return the data directly (which includes the token)
};

/* export const getCatgory = async (body) => {
    const response = await instance.get(`${GETCATEGORY}`);
    return response;  // Return the data directly (which includes the token)
};
export const getUsers = async (body) => {
    const response = await instance.get(`${GETUSERS}`);
    return response;  // Return the data directly (which includes the token)
};
export const getOrders = async (body) => {
    const response = await instance.get(`${GETORDERS}`);
    return response;  // Return the data directly (which includes the token)
};
export const getProduct = async (body) => {
    const response = await instance.get(`${GETPRODUCT}`);
    return response;  // Return the data directly (which includes the token)
};
export const addCatgory = async (body) => {
    const response = await instance.post(`${ADDCATEGORY}`, body);
    return response;  // Return the data directly (which includes the token)
};
export const sendMail = async (body) => {
    const response = await instance.post(`${EMAILSERVER}`, body);
    return response;  // Return the data directly (which includes the token)
};
export const sendPeyment = async (body) => {
    const response = await instance.post(`${PEYMENT}`, body);
    return response;  // Return the data directly (which includes the token)
};
export const vrifyPeyment = async (body) => {
    const response = await instance.post(`${PEYMENTVR}`, body);
    return response;  // Return the data directly (which includes the token)
};
export const addOrder = async (body) => {
    const response = await instance.post(`${SENDORDER}`, body);
    return response;  // Return the data directly (which includes the token)
};
export const addProducts = async (body) => {
    const response = await instance.post(`${ADDPRODUCTS}`, body);
    return response;  // Return the data directly (which includes the token)
};

export const deleteItem = async (URL) => {
    const response = await instance.delete(`${URL}`);
    return response;  // Return the data directly (which includes the token)
};
export const editItem = async (URL,body) => {
    const response = await instance.put(`${URL}`,body);
    return response;  // Return the data directly (which includes the token)
};

export const signUp = async (body) => {
    return await instance.post(`${SIGNUP}`, body);
};

export const uploudImage = async (body) => {
    return await instanceex.post(`${UPLOUDIMAGE}`, body);
};

export const logout = async (token) => {
    return await instance.get(`/logout`, setParams("", token));
};


// export const getServices = async () => {
//     return await instance.get(`/services`, setParams("", token));
// }; */